import apiUrls from "../api/apiUrlsSharePage";
import getThumbRendition from "./getThumbRendition";
const getSPPreviewSrcUrl = ({ size, fileId, mimeType, mimeTypeToMediaKind, }) => {
    if (!fileId)
        return "";
    return apiUrls.mediaDownload.url(fileId, getThumbRendition(size, mimeType, mimeTypeToMediaKind));
};
export default getSPPreviewSrcUrl;
